/* Raz Ruya — quick view helper (homepage product carousels).

   Dawn's quick view pop-up loads the product's own form into the page,
   including the custom-size measurement fields from
   snippets/buy-buttons.liquid. That script is left exactly as it is; it
   starts its work on "DOMContentLoaded", which has already happened by the
   time a pop-up opens, so on its own it would never start inside the pop-up
   (the measurement fields would stay hidden).

   While Dawn is putting a product into a quick view pop-up — and only then —
   this hands such "when the page is ready" code to the browser to run
   straight away, exactly as it runs on the product page. */
(function () {
  if (typeof HTMLUpdateUtility === 'undefined' || HTMLUpdateUtility.rzQuickView) return;

  var setInnerHTML = HTMLUpdateUtility.setInnerHTML;

  HTMLUpdateUtility.setInnerHTML = function (element, html) {
    var isQuickView = element && typeof element.id === 'string' && element.id.indexOf('QuickAddInfo-') === 0;
    if (!isQuickView || document.readyState === 'loading') return setInnerHTML.apply(this, arguments);

    var addEventListener = document.addEventListener;
    var readyListeners = [];

    document.addEventListener = function (type, listener, options) {
      if (type === 'DOMContentLoaded') {
        readyListeners.push(listener);
        return;
      }
      return addEventListener.call(document, type, listener, options);
    };

    try {
      return setInnerHTML.apply(this, arguments);
    } finally {
      document.addEventListener = addEventListener;
      readyListeners.forEach(function (listener) {
        setTimeout(function () {
          var event = new Event('DOMContentLoaded');
          try {
            if (typeof listener === 'function') listener.call(document, event);
            else if (listener && typeof listener.handleEvent === 'function') listener.handleEvent(event);
          } catch (error) {
            console.error(error);
          }
        }, 0);
      });
    }
  };

  HTMLUpdateUtility.rzQuickView = true;
})();
